<template>
  <el-drawer
    custom-class="initSample-drawer"
    title="添加样本"
    :visible.sync="visible"
    direction="rtl"
    :size="974"
    :destroy-on-close="true"
    append-to-body
    :before-close="handleClose"
  >
    <div class="timeline-wrap">
      <div class="timeline-left">
        <i class="icon-circle">1</i>
        <i class="icon-line"></i>
        <i class="icon-circle">2</i>
      </div>
      <div class="timeline-content">
        <p class="timeline-content-title">创建样本群组，并在群组中添加样本</p>
        <el-button type="primary" @click="()=>{
          this.$router.push({name:'sample-company'})
        }">创建样本群组</el-button>
        <p class="timeline-content-text">创建样本群组后，请 <strong @click="refresh">刷新</strong> 本页面</p>
        <p class="timeline-content-title mt212">选择样本群组中的样本，分配给调查员</p>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name:'InitSample',
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
    }
  },
  methods:{
    handleClose(){
      this.$emit('handleClose',false);
    },
    // 添加样本按钮
    refresh(){
      // 判断当前是否已经有样本数据
      this.$emit('handleRefresh',true);
    },
  },
  mounted(){

  },
}
</script>
<style lang="scss" scoped>
::v-deep{
  .initSample-drawer{
    background: #fff;
    .el-drawer__body{
      padding: 24px 16px;
      .timeline-wrap{
        display: flex;
        width: 100%;
        .timeline-left{
          width: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .icon-circle{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #CCCCCC;
            color: #fff;
            text-align: center;
            opacity: 0.85;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: rgba(255,255,255,0.85);
            line-height: 22px;
          }
          .icon-line{
            margin-top: 5px;
            margin-bottom: 5px;
            width: 1px;
            height: 288px;
            background: #CCCCCC;
          }
        }
        .timeline-content{
          flex: 1;
          margin-left: 12px;
          .timeline-content-title{
            height: 22px;
            opacity: 0.85;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 16px;
            color: rgba(0,0,0,0.85);;
            line-height: 22px;
            margin-bottom: 16px;
            &.mt212{
              margin-top: 209px;
            }
          }
          .timeline-content-text{
            margin-top: 16px;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            line-height: 22px;
            strong{
              font-weight: 400;
              color: rgba(39, 117, 232, 1);
              cursor: pointer;
            }
          }
        }
      }
    }
  }

}
</style>